<template>
  <div>
    <table v-if="!showError" aria-describedby="Additional-scores-list">
      <thead>
        <tr>
          <th>Score Name</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sortedVariablesScoresList" :key="`additional-score-${item.id}-${index}`">
          <td :title="item.formulaName" class="ellipsis">
            <span>{{ item.formulaName }}</span>
          </td>
          <td :title="item.score || item.score === 0 ? item.score : item.errorMessage" class="ellipsis">
            <span>{{ item.score || item.score === 0 ? item.score : item.errorMessage }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div data-testid="error-message" v-else>
      Scoring data is currently not available. Please refresh your page or contact
      <a href="https://support.threadresearch.com/hc/en-us" target="_blank">THREAD Support</a>
      for assistance.
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
export default {
  props: {
    variablesList: {
      default: () => [],
      type: Array
    },
    participantId: {
      type: String
    },
    studyId: {
      type: String
    },
    surveyId: {
      type: String
    },
    surveyResponseVersionId: {
      type: String
    },
    responseId: {
      type: String
    },
    responseVersionId: {
      type: String
    }
  },
  data() {
    return {
      variablesScoresList: [],
      showError: false
    };
  },
  computed: {
    sortedVariablesScoresList() {
      const mappedArray = this.variablesList;
      return mappedArray
        .sort(({ createAt: a }, { createdAt: b }) => a - b)
        .map(variable => ({
          ...variable,
          ...(this.variablesScoresList.find(score => score.formulaName === variable.name) || {})
        }));
    }
  },
  methods: {
    async getVariablesScoresList() {
      try {
        nprogress.start();

        // The activityId from the URL differs from variable's
        // so we get the `activityId` and `revisionId` search the first variable item

        if (!this.variablesList.length) {
          return;
        }

        if (this.surveyId && !this.surveyResponseVersionId) {
          return;
        }

        if (this.responseId && !this.responseVersionId) {
          return;
        }

        const activityId = this.variablesList[0].activityId;
        const activityRevisionId = this.variablesList[0].activityRevisionId;

        const pathParams = {
          studyId: this.studyId,
          participantId: this.participantId,
          activityId,
          activityRevisionId
        };

        const queryParams = this.surveyId
          ? {
              surveyId: this.surveyId,
              surveyResponseVersionId: this.surveyResponseVersionId
            }
          : {
              responseId: this.responseId,
              responseVersionId: this.responseVersionId
            };

        const response = await this.$api.getVariablesScores(pathParams, queryParams);
        this.variablesScoresList = response.body;

      } catch (error) {
        this.showError = true;
        this.variablesScoresList = [];
      } finally {
        nprogress.done();
      }
    }
  },
  mounted() {
    this.getVariablesScoresList();
    this.$root.$on("edcUpdateScoreValueTab", (responseVersionId, responseId) => {
      this.responseVersionId = responseVersionId;
      this.responseId = responseId;
      this.getVariablesScoresList();
    });
    this.$root.$on("surveyUpdateScoreValueTab", (surveyId, surveyResponseVersionId) => {
      this.surveyId = surveyId;
      this.surveyResponseVersionId = surveyResponseVersionId;
      this.getVariablesScoresList();
    });
  },
  beforeDestroy() {
    this.$root.$off("edcUpdateScoreValueTab");
    this.$root.$off("surveyUpdateScoreValueTab");
  }
};
</script>

<style scoped lang="scss">
table {
  width: 100%;

  thead {
    tr {
      background: #f9f9fb;
      padding-left: 30px;
      width: 100%;
      display: flex;

      th {
        width: 300px;
        font-size: 14px;
        font-family: Roboto-Bold;
        color: #4a4a4a;
        padding: 15px 30px 15px 0px;

        &:first-child {
          border-right: 4px solid #fff;
          width: 300px;
        }

        &:last-child {
          width: 100%;
          padding-left: 16px;
        }
      }
    }
  }

  tbody {
    tr {
      display: flex;
      width: 95%;
      border-bottom: 1px solid #d3dfe4;
      margin-left: 30px;

      td {
        font-size: 12px;
        font-family: Roboto-Bold;
        color: #4a4a4a;
        padding: 15px 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        &.ellipsis {
          position: relative;
        }
        &.ellipsis:before {
          content: "&nbsp;";
          visibility: hidden;
        }
        &.ellipsis span {
          position: absolute;
          left: 0;
          right: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:first-child {
          width: 300px;
        }

        &:last-child {
          font-family: Roboto-Regular;
          font-size: 14px;
          span {
            padding-left: 20px;
          }
        }
      }
    }
  }
}
</style>
